import { render, staticRenderFns } from "./homPage.vue?vue&type=template&id=3335b646"
import script from "./homPage.vue?vue&type=script&lang=js"
export * from "./homPage.vue?vue&type=script&lang=js"
import style0 from "./homPage.vue?vue&type=style&index=0&id=3335b646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports